import { useCallback } from 'react';
import type { MusicVideoClipSource } from 'fym-shared/src/music24/musicVideoDoc';
import { footageKey } from '../footage/footageView';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { newDocId } from './clipIds';
import type { ClipLimits } from './clipOps';

/** A source whose length the caller knows already (the dragged card), before the catalog has it. */
export interface KnownSourceLength {
  source: MusicVideoClipSource;
  durationSec: number | null;
}

/**
 * The limits of the clip edits (`ClipLimits`): the source lengths from the footage catalog of the
 * editor, and new clip ids for the repeats of a loop. `known` gives the length of a source that the
 * catalog does not hold yet.
 */
export function useClipLimits(): (known?: KnownSourceLength) => ClipLimits {
  const { footage } = useMusicVideoEditor();
  const { lookup } = footage;
  return useCallback(
    (known?: KnownSourceLength): ClipLimits => ({
      lengthOf: (source) =>
        known !== undefined && footageKey(known.source) === footageKey(source)
          ? known.durationSec
          : (lookup(source)?.durationSec ?? null),
      makeId: () => newDocId(),
    }),
    [lookup]
  );
}
